// extracted by mini-css-extract-plugin
export default {"containerList":"DetailedStock_containerList__9iKHc","submitButton":"DetailedStock_submitButton__beIZE","dropdown":"DetailedStock_dropdown__VnNfj","icon":"DetailedStock_icon__iNWBe"};